<template>
  <div class="devices">

    <b-card no-body>
      <b-tabs v-model="tabIndex" card>

        <!-- Render Tabs, supply a unique `key` to each tab -->
        <b-tab v-for="(data, index) in architectureTabs" :key="index" :title="data.name" @click="retrieveData(data.type, data.node)">
          <p v-if="data.type != 'config'">{{data.name}} - Última medida: {{ lastMeassurement || "No hay datos" }}</p>
          <p v-else>{{data.name}}</p>
          <!-- <SVG_Filters status='success'></SVG_Filters> -->

          <div v-if="data.type == 'smallGrit'">

            <p>Datos de granalla pequeña</p>
            <div>
              <table>
                <tr>
                  <th class="border p-2 text-center p-2">Entre filtro 2 y motor</th>
                  <th class="border p-2 text-center p-2">Entre filtro 1 y 2 (derecho)</th>
                  <th class="border p-2 text-center p-2">Entre filtro 1 y 2 (izquierdo)</th>
                  <th class="border p-2 text-center p-2">Cámara</th>
                  <th class="border p-2 text-center p-2">Estado filtro derecho</th>
                  <th class="border p-2 text-center p-2">Estado filtro izquierdo</th>
                </tr>
                <tr v-if="isLoading" ><td colspan="12" class="border py-5 text-center fw-bold"><h2>CARGANDO DATOS</h2></td></tr>
                <tr v-if="smallGritData.length > 0">
                  <td class="border p-2 text-center p-2">{{ smallGritData[0]? smallGritData[0].filter2engine : '-' }}</td>
                  <td class="border p-2 text-center p-2">{{ smallGritData[0]? smallGritData[0].filterRight : '-' }}</td>
                  <td class="border p-2 text-center p-2">{{ smallGritData[0]? smallGritData[0].filterLeft : '-' }}</td>
                  <td class="border p-2 text-center p-2">{{ smallGritData[1]? smallGritData[1].chamberPressure : '-' }}</td>
                  <td class="border p-2 text-center p-2 fw-bold" :class="smallGritData[0]? smallGritData[0].statusRight.class : ''">{{ smallGritData[0]? smallGritData[0].statusRight.message : '-' }}</td>
                  <td class="border p-2 text-center p-2 fw-bold" :class="smallGritData[0]? smallGritData[0].statusLeft.class : ''">{{ smallGritData[0]? smallGritData[0].statusLeft.message : '-' }}</td>
                </tr>
                <tr v-if="!isLoading && smallGritData.length == 0"><td colspan="12" class="border py-5 text-center fw-bold"><h2>NO HAY DATOS</h2></td></tr>
              </table>
            </div>
          </div>

          <div v-if="data.type == 'largeGrit'">
            <div>
              <p>Datos de granalla grande para el motor 1:</p>
              <table>
                <tr>
                  <th class="border p-2 text-center p-2">Entre filtro 2 y motor 1</th>
                  <th class="border p-2 text-center p-2">Entre filtro 1 y 2 (derecho)</th>
                  <th class="border p-2 text-center p-2">Entre filtro 1 y 2 (izquierdo)</th>
                  <th class="border p-2 text-center p-2">Cámara</th>
                  <th class="border p-2 text-center p-2">Estado filtro derecho</th>
                  <th class="border p-2 text-center p-2">Estado filtro izquierdo</th>
                </tr>
                <tr v-if="isLoading" ><td colspan="7" class="border py-5 text-center fw-bold"><h2>CARGANDO DATOS</h2></td></tr>
                <tr v-if="largeGritData.length > 0">
                  <td class="border p-2 text-center p-2">{{ largeGritData[1]? largeGritData[1].filter2engine : '-' }}</td>
                  <td class="border p-2 text-center p-2">{{ largeGritData[1]? largeGritData[1].filterRight : '-' }}</td>
                  <td class="border p-2 text-center p-2">{{ largeGritData[1]? largeGritData[1].filterLeft : '-' }}</td>
                  <td class="border p-2 text-center p-2">{{ largeGritData[0]? largeGritData[0].chamberPressure : '-' }}</td>
                  <td class="border p-2 text-center p-2 fw-bold" :class="largeGritData[1]? largeGritData[1].statusRight.class : ''">{{ largeGritData[1]? largeGritData[1].statusRight.message : '-' }}</td>
                  <td class="border p-2 text-center p-2 fw-bold" :class="largeGritData[1]? largeGritData[1].statusLeft.class : ''">{{ largeGritData[1]? largeGritData[1].statusLeft.message : '-' }}</td>
                </tr>
                <tr v-if="!isLoading && largeGritData.length == 0"><td colspan="7" class="border py-5 text-center fw-bold"><h2>NO HAY DATOS</h2></td></tr>
              </table>
              <p class="mt-4">Datos de granalla grande para el motor 2:</p>
              <table>
                <tr>
                  <th class="border p-2 text-center p-2">Entre filtro 2 y motor 2</th>
                  <th class="border p-2 text-center p-2">Entre filtro 1 y 2 (derecho)</th>
                  <th class="border p-2 text-center p-2">Entre filtro 1 y 2 (izquierdo)</th>
                  <th class="border p-2 text-center p-2">Cámara</th>
                  <th class="border p-2 text-center p-2">Estado filtro derecho</th>
                  <th class="border p-2 text-center p-2">Estado filtro izquierdo</th>
                </tr>
                <tr v-if="isLoading" ><td colspan="7" class="border py-5 text-center fw-bold"><h2>CARGANDO DATOS</h2></td></tr>
                <tr v-if="largeGritData.length > 0">
                  <td class="border p-2 text-center p-2">{{ largeGritData[2]? largeGritData[2].filter2engineBis : '-' }}</td>
                  <td class="border p-2 text-center p-2">{{ largeGritData[2]? largeGritData[2].filterRightBis : '-' }}</td>
                  <td class="border p-2 text-center p-2">{{ largeGritData[2]? largeGritData[2].filterLeftBis : '-' }}</td>
                  <td class="border p-2 text-center p-2">{{ largeGritData[0]? largeGritData[0].chamberPressure : '-' }}</td>
                  <td class="border p-2 text-center p-2 fw-bold" :class="largeGritData[2]? largeGritData[2].statusRightBis.class : ''">{{ largeGritData[2]? largeGritData[2].statusRightBis.message : '-' }}</td>
                  <td class="border p-2 text-center p-2 fw-bold" :class="largeGritData[2]? largeGritData[2].statusLeftBis.class : ''">{{ largeGritData[2]? largeGritData[2].statusLeftBis.message : '-' }}</td>
                </tr>
                <tr v-if="!isLoading && largeGritData.length == 0"><td colspan="7" class="border py-5 text-center fw-bold"><h2>NO HAY DATOS</h2></td></tr>
              </table>
            </div>
          </div>

          <div v-if="data.type == 'newPaint'">

            <p>Datos de pintura nueva para filtro 1 (Extracción):</p>
            <table>
              <tr>
                <th class="border p-2 text-center p-2">Cámara</th>
                <th class="border p-2 text-center p-2">Entre filtro 1 y filtros 2</th>
                <th class="border p-2 text-center p-2">Estado del filtro 1 (extracción)</th>
              </tr>
              <tr v-if="isLoading" ><td colspan="7" class="border py-5 text-center fw-bold"><h2>CARGANDO DATOS</h2></td></tr>
              <tr v-if="newPaintData.length > 0">
                <td class="border p-2 text-center p-2">{{ newPaintData[0]? newPaintData[0].chamberPressure : '-' }}</td>
                <td class="border p-2 text-center p-2">{{ newPaintData[1]? newPaintData[1].filterLeftRight : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="newPaintData[1]? newPaintData[1].statusRight.class : ''">{{ newPaintData[1]? newPaintData[1].statusRight.message : '-' }}</td>
              </tr>
              <tr v-if="!isLoading && newPaintData.length == 0"><td colspan="7" class="border py-5 text-center fw-bold"><h2>NO HAY DATOS</h2></td></tr>
            </table>

            <p class="mt-4">Datos de pintura nueva para filtros 2 (Extracción):</p>
            <table>
              <tr>
                <th class="border p-2 text-center p-2">Motor</th>
                <th class="border p-2 text-center p-2">Entre filtro 2 y Motor</th>
                <th class="border p-2 text-center p-2">Estado del filtro 2 (extracción)</th>
              </tr>
              <tr v-if="isLoading" ><td colspan="7" class="border py-5 text-center fw-bold"><h2>CARGANDO DATOS</h2></td></tr>
              <tr v-if="newPaintData.length > 0">
                <td class="border p-2 text-center p-2">M1</td>
                <td class="border p-2 text-center p-2">{{ newPaintData[2]? newPaintData[2].filter2engine_1 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="newPaintData[2]? newPaintData[2].statusFilterEngine_1.class : ''">{{ newPaintData[2]? newPaintData[2].statusFilterEngine_1.message : '-' }}</td>
              </tr>
              <tr v-if="newPaintData.length > 0">
                <td class="border p-2 text-center p-2">M2</td>
                <td class="border p-2 text-center p-2">{{ newPaintData[2]? newPaintData[2].filter2engine_2 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="newPaintData[2]? newPaintData[2].statusFilterEngine_2.class : ''">{{ newPaintData[2]? newPaintData[2].statusFilterEngine_2.message : '-' }}</td>
              </tr>
              <tr v-if="newPaintData.length > 0">
                <td class="border p-2 text-center p-2">M3</td>
                <td class="border p-2 text-center p-2">{{ newPaintData[2]? newPaintData[2].filter2engine_3 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="newPaintData[2]? newPaintData[2].statusFilterEngine_3.class : ''">{{ newPaintData[2]? newPaintData[2].statusFilterEngine_3.message : '-' }}</td>
              </tr>
              <tr v-if="newPaintData.length > 0">
                <td class="border p-2 text-center p-2">M4</td>
                <td class="border p-2 text-center p-2">{{ newPaintData[2]? newPaintData[2].filter2engine_4 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="newPaintData[2]? newPaintData[2].statusFilterEngine_4.class : ''">{{ newPaintData[2]? newPaintData[2].statusFilterEngine_4.message : '-' }}</td>
              </tr>
              <tr v-if="newPaintData.length > 0">
                <td class="border p-2 text-center p-2">M5</td>
                <td class="border p-2 text-center p-2">{{ newPaintData[2]? newPaintData[2].filter2engine_5 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="newPaintData[2]? newPaintData[2].statusFilterEngine_5.class : ''">{{ newPaintData[2]? newPaintData[2].statusFilterEngine_5.message : '-' }}</td>
              </tr>
              <tr v-if="!isLoading && newPaintData.length == 0"><td colspan="7" class="border py-5 text-center fw-bold"><h2>NO HAY DATOS</h2></td></tr>
            </table>

            <p class="mt-4">Datos de pintura nueva para filtro 1 (Impulsión):</p>
            <table>
              <tr>
                <th class="border p-2 text-center p-2">Motor</th>
                <th class="border p-2 text-center p-2">Cámara</th>
                <th class="border p-2 text-center p-2">Entre filtro 1 y filtro 2</th>
                <th class="border p-2 text-center p-2">Estado del filtro 1 (Impulsión)</th>
              </tr>
              <tr v-if="isLoading" ><td colspan="7" class="border py-5 text-center fw-bold"><h2>CARGANDO DATOS</h2></td></tr>
              <tr v-if="newPaintData.length > 0">
                <td class="border p-2 text-center p-2">M1</td>
                <td class="border p-2 text-center p-2">{{ newPaintData[3]? newPaintData[3].chamberPressure : '-' }}</td>
                <td class="border p-2 text-center p-2">{{ newPaintData[4]? newPaintData[4].filterLeftRight_1 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="newPaintData[4]? newPaintData[4].statusRight_1.class : ''">{{ newPaintData[4]? newPaintData[4].statusRight_1.message : '-' }}</td>
              </tr>
              <tr v-if="newPaintData.length > 0">
                <td class="border p-2 text-center p-2">M2</td>
                <td class="border p-2 text-center p-2">{{ newPaintData[3]? newPaintData[3].chamberPressure : '-' }}</td>
                <td class="border p-2 text-center p-2">{{ newPaintData[4]? newPaintData[4].filterLeftRight_2 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="newPaintData[4]? newPaintData[4].statusRight_2.class : ''">{{ newPaintData[4]? newPaintData[4].statusRight_2.message : '-' }}</td>
              </tr>
              <tr v-if="newPaintData.length > 0">
                <td class="border p-2 text-center p-2">M3</td>
                <td class="border p-2 text-center p-2">{{ newPaintData[3]? newPaintData[3].chamberPressure : '-' }}</td>
                <td class="border p-2 text-center p-2">{{ newPaintData[4]? newPaintData[4].filterLeftRight_3 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="newPaintData[4]? newPaintData[4].statusRight_3.class : ''">{{ newPaintData[4]? newPaintData[4].statusRight_3.message : '-' }}</td>
              </tr>
              <tr v-if="!isLoading && newPaintData.length == 0"><td colspan="7" class="border py-5 text-center fw-bold"><h2>NO HAY DATOS</h2></td></tr>
            </table>

            <p class="mt-4">Datos de pintura nueva para filtros 2 (Impulsión):</p>
            <table>
              <tr>
                <th class="border p-2 text-center p-2">Motor</th>
                <th class="border p-2 text-center p-2">Entre filtro 2 y Motor</th>
                <th class="border p-2 text-center p-2">Estado del filtro 2 (impulsión)</th>
              </tr>
              <tr v-if="isLoading" ><td colspan="7" class="border py-5 text-center fw-bold"><h2>CARGANDO DATOS</h2></td></tr>
              <tr v-if="newPaintData.length > 0">
                <td class="border p-2 text-center p-2">M1</td>
                <td class="border p-2 text-center p-2">{{ newPaintData[5]? newPaintData[5].filter2engine_1 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="newPaintData[5]? newPaintData[5].statusFilterEngine_1.class : ''">{{ newPaintData[5]? newPaintData[5].statusFilterEngine_1.message : '-' }}</td>
              </tr>
              <tr v-if="newPaintData.length > 0">
                <td class="border p-2 text-center p-2">M2</td>
                <td class="border p-2 text-center p-2">{{ newPaintData[5]? newPaintData[5].filter2engine_2 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="newPaintData[5]? newPaintData[5].statusFilterEngine_2.class : ''">{{ newPaintData[5]? newPaintData[5].statusFilterEngine_2.message : '-' }}</td>
              </tr>
              <tr v-if="newPaintData.length > 0">
                <td class="border p-2 text-center p-2">M3</td>
                <td class="border p-2 text-center p-2">{{ newPaintData[5]? newPaintData[5].filter2engine_3 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="newPaintData[5]? newPaintData[5].statusFilterEngine_3.class : ''">{{ newPaintData[5]? newPaintData[5].statusFilterEngine_3.message : '-' }}</td>
              </tr>
              <tr v-if="!isLoading && newPaintData.length == 0"><td colspan="7" class="border py-5 text-center fw-bold"><h2>NO HAY DATOS</h2></td></tr>
            </table>
          </div>

          <div v-if="data.type == 'oldPaint'">

            <p>Datos de pintura antigua para filtro 1 (Extracción):</p>
            <table>
              <tr>
                <th class="border p-2 text-center p-2">Cámara</th>
                <th class="border p-2 text-center p-2">Entre filtro 1 y filtros 2</th>
                <th class="border p-2 text-center p-2">Estado del filtro 1 (extracción)</th>
              </tr>
              <tr v-if="isLoading" ><td colspan="7" class="border py-5 text-center fw-bold"><h2>CARGANDO DATOS</h2></td></tr>
              <tr v-if="oldPaintData.length > 0">
                <td class="border p-2 text-center p-2">{{ oldPaintData[0]? oldPaintData[0].chamberPressure : '-' }}</td>
                <td class="border p-2 text-center p-2">{{ oldPaintData[1]? oldPaintData[1].filterLeftRight : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="oldPaintData[1]? oldPaintData[1].statusRight.class : ''">{{ oldPaintData[1]? oldPaintData[1].statusRight.message : '-' }}</td>
              </tr>
              <tr v-if="!isLoading && oldPaintData.length == 0"><td colspan="7" class="border py-5 text-center fw-bold"><h2>NO HAY DATOS</h2></td></tr>
            </table>

            <p class="mt-4">Datos de pintura antigua para filtros 2 (Extracción):</p>
            <table>
              <tr>
                <th class="border p-2 text-center p-2">Motor</th>
                <th class="border p-2 text-center p-2">Entre filtro 2 y Motor</th>
                <th class="border p-2 text-center p-2">Estado del filtro 2 (extracción)</th>
              </tr>
              <tr v-if="isLoading" ><td colspan="7" class="border py-5 text-center fw-bold"><h2>CARGANDO DATOS</h2></td></tr>
              <tr v-if="oldPaintData.length > 0">
                <td class="border p-2 text-center p-2">M1</td>
                <td class="border p-2 text-center p-2">{{ oldPaintData[2]? oldPaintData[2].filter2engine_1 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="oldPaintData[2]? oldPaintData[2].statusFilterEngine_1.class : ''">{{ oldPaintData[2]? oldPaintData[2].statusFilterEngine_1.message : '-' }}</td>
              </tr>
              <tr v-if="oldPaintData.length > 0">
                <td class="border p-2 text-center p-2">M2</td>
                <td class="border p-2 text-center p-2">{{ oldPaintData[2]? oldPaintData[2].filter2engine_2 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="oldPaintData[2]? oldPaintData[2].statusFilterEngine_2.class : ''">{{ oldPaintData[2]? oldPaintData[2].statusFilterEngine_2.message : '-' }}</td>
              </tr>
              <tr v-if="oldPaintData.length > 0">
                <td class="border p-2 text-center p-2">M3</td>
                <td class="border p-2 text-center p-2">{{ oldPaintData[2]? oldPaintData[2].filter2engine_3 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="oldPaintData[2]? oldPaintData[2].statusFilterEngine_3.class : ''">{{ oldPaintData[2]? oldPaintData[2].statusFilterEngine_3.message : '-' }}</td>
              </tr>
              <tr v-if="oldPaintData.length > 0">
                <td class="border p-2 text-center p-2">M4</td>
                <td class="border p-2 text-center p-2">{{ oldPaintData[2]? oldPaintData[2].filter2engine_4 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="oldPaintData[2]? oldPaintData[2].statusFilterEngine_4.class : ''">{{ oldPaintData[2]? oldPaintData[2].statusFilterEngine_4.message : '-' }}</td>
              </tr>
              <tr v-if="oldPaintData.length > 0">
                <td class="border p-2 text-center p-2">M5</td>
                <td class="border p-2 text-center p-2">{{ oldPaintData[3]? oldPaintData[3].filter2engine_5 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="oldPaintData[3]? oldPaintData[3].statusFilterEngine_5.class : ''">{{ oldPaintData[3]? oldPaintData[3].statusFilterEngine_5.message : '-' }}</td>
              </tr>
              <tr v-if="oldPaintData.length > 0">
                <td class="border p-2 text-center p-2">M6</td>
                <td class="border p-2 text-center p-2">{{ oldPaintData[3]? oldPaintData[3].filter2engine_6 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="oldPaintData[3]? oldPaintData[3].statusFilterEngine_6.class : ''">{{ oldPaintData[3]? oldPaintData[3].statusFilterEngine_6.message : '-' }}</td>
              </tr>
              <tr v-if="oldPaintData.length > 0">
                <td class="border p-2 text-center p-2">M7</td>
                <td class="border p-2 text-center p-2">{{ oldPaintData[3]? oldPaintData[3].filter2engine_7 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="oldPaintData[3]? oldPaintData[3].statusFilterEngine_7.class : ''">{{ oldPaintData[3]? oldPaintData[3].statusFilterEngine_7.message : '-' }}</td>
              </tr>
              <tr v-if="oldPaintData.length > 0">
                <td class="border p-2 text-center p-2">M8</td>
                <td class="border p-2 text-center p-2">{{ oldPaintData[3]? oldPaintData[3].filter2engine_8 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="oldPaintData[3]? oldPaintData[3].statusFilterEngine_8.class : ''">{{ oldPaintData[3]? oldPaintData[3].statusFilterEngine_8.message : '-' }}</td>
              </tr>
              <tr v-if="!isLoading && oldPaintData.length == 0"><td colspan="7" class="border py-5 text-center fw-bold"><h2>NO HAY DATOS</h2></td></tr>
            </table>

            <p class="mt-4">Datos de pintura antigua para filtro 1 (Impulsión):</p>
            <table>
              <tr>
                <th class="border p-2 text-center p-2">Motor</th>
                <th class="border p-2 text-center p-2">Cámara</th>
                <th class="border p-2 text-center p-2">Entre filtro 1 y filtro 2</th>
                <th class="border p-2 text-center p-2">Estado del filtro 1 (Impulsión)</th>
              </tr>
              <tr v-if="isLoading" ><td colspan="7" class="border py-5 text-center fw-bold"><h2>CARGANDO DATOS</h2></td></tr>
              <tr v-if="oldPaintData.length > 0">
                <td class="border p-2 text-center p-2">M1</td>
                <td class="border p-2 text-center p-2">{{ oldPaintData[4]? oldPaintData[4].chamberPressure : '-' }}</td>
                <td class="border p-2 text-center p-2">{{ oldPaintData[5]? oldPaintData[5].filterLeftRight_1 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="oldPaintData[5]? oldPaintData[5].statusRight_1.class : ''">{{ oldPaintData[5]? oldPaintData[5].statusRight_1.message : '-' }}</td>
              </tr>
              <tr v-if="oldPaintData.length > 0">
                <td class="border p-2 text-center p-2">M2</td>
                <td class="border p-2 text-center p-2">{{ oldPaintData[4]? oldPaintData[4].chamberPressure : '-' }}</td>
                <td class="border p-2 text-center p-2">{{ oldPaintData[5]? oldPaintData[5].filterLeftRight_2 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="oldPaintData[5]? oldPaintData[5].statusRight_2.class : ''">{{ oldPaintData[5]? oldPaintData[5].statusRight_2.message : '-' }}</td>
              </tr>
              <tr v-if="oldPaintData.length > 0">
                <td class="border p-2 text-center p-2">M3</td>
                <td class="border p-2 text-center p-2">{{ oldPaintData[4]? oldPaintData[4].chamberPressure : '-' }}</td>
                <td class="border p-2 text-center p-2">{{ oldPaintData[5]? oldPaintData[5].filterLeftRight_3 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="oldPaintData[5]? oldPaintData[5].statusRight_3.class : ''">{{ oldPaintData[5]? oldPaintData[5].statusRight_3.message : '-' }}</td>
              </tr>
              <tr v-if="!isLoading && oldPaintData.length == 0"><td colspan="7" class="border py-5 text-center fw-bold"><h2>NO HAY DATOS</h2></td></tr>
            </table>

            <p class="mt-4">Datos de pintura antigua para filtros 2 (Impulsión):</p>
            <table>
              <tr>
                <th class="border p-2 text-center p-2">Motor</th>
                <th class="border p-2 text-center p-2">Entre filtro 2 y Motor</th>
                <th class="border p-2 text-center p-2">Estado del filtro 2 (impulsión)</th>
              </tr>
              <tr v-if="isLoading" ><td colspan="7" class="border py-5 text-center fw-bold"><h2>CARGANDO DATOS</h2></td></tr>
              <tr v-if="oldPaintData.length > 0">
                <td class="border p-2 text-center p-2">M1</td>
                <td class="border p-2 text-center p-2">{{ oldPaintData[6]? oldPaintData[6].filter2engine_1 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="oldPaintData[6]? oldPaintData[6].statusFilterEngine_1.class : ''">{{ oldPaintData[6]? oldPaintData[6].statusFilterEngine_1.message : '-' }}</td>
              </tr>
              <tr v-if="oldPaintData.length > 0">
                <td class="border p-2 text-center p-2">M2</td>
                <td class="border p-2 text-center p-2">{{ oldPaintData[6]? oldPaintData[6].filter2engine_2 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="oldPaintData[6]? oldPaintData[6].statusFilterEngine_2.class : ''">{{ oldPaintData[6]? oldPaintData[6].statusFilterEngine_2.message : '-' }}</td>
              </tr>
              <tr v-if="oldPaintData.length > 0">
                <td class="border p-2 text-center p-2">M3</td>
                <td class="border p-2 text-center p-2">{{ oldPaintData[6]? oldPaintData[6].filter2engine_3 : '-' }}</td>
                <td class="border p-2 text-center p-2 fw-bold" :class="oldPaintData[6]? oldPaintData[6].statusFilterEngine_3.class : ''">{{ oldPaintData[6]? oldPaintData[6].statusFilterEngine_3.message : '-' }}</td>
              </tr>
              <tr v-if="!isLoading && oldPaintData.length == 0"><td colspan="7" class="border py-5 text-center fw-bold"><h2>NO HAY DATOS</h2></td></tr>
            </table>
          </div>

          <div v-if="data.type == 'config'">
            <b-form @submit="saveData">
              <span class="small text-success">Filtro de granalla pequeña</span><br>
              <b-form-group
                label-size="sm"
                label="Seleccione el nodo que mide las presiones en los filtros izquierdo y derecho"
                label-for="smallLR"
                style="max-width: 500px;"
              >
                <b-form-select
                  id="smallLR"
                  name="smallLR"
                  size="sm"
                  v-model="architectureTabs[0].node[0].uuidNodo"
                  style="cursor: pointer"
                >
                  <b-form-select-option value="null"
                    >No especificado</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="data in selectPressureNodes"
                    v-bind:key="data"
                    v-bind:value="data"
                  >
                    {{ data }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label="Seleccione el nodo que mide la presión en la cámara"
                label-for="smallChamber"
                style="max-width: 500px;"
              >
                <b-form-select
                  id="smallChamber"
                  name="smallChamber"
                  size="sm"
                  v-model="architectureTabs[0].node[1].uuidNodo"
                  style="cursor: pointer"
                >
                  <b-form-select-option value="null"
                    >No especificado</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="data in selectPressureNodes"
                    v-bind:key="data"
                    v-bind:value="data"
                  >
                    {{ data }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
              <span class="small text-success mt-4">Filtro de granalla grande</span><br>
              <b-form-group
                label-size="sm"
                label="Seleccione el nodo que mide las presiones en los filtros izquierdo y derecho del primer motor"
                label-for="largeLR"
                style="max-width: 500px;"
              >
                <b-form-select
                  id="largeLR"
                  name="largeLR"
                  size="sm"
                  v-model="architectureTabs[1].node[1].uuidNodo"
                  style="cursor: pointer"
                >
                  <b-form-select-option value="null"
                    >No especificado</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="data in selectPressureNodes"
                    v-bind:key="data"
                    v-bind:value="data"
                  >
                    {{ data }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label="Seleccione el nodo que mide las presiones en los filtros izquierdo y derecho del segundo motor"
                label-for="largeLRbis"
                style="max-width: 500px;"
              >
                <b-form-select
                  id="largeLRbis"
                  name="largeLRbis"
                  size="sm"
                  v-model="architectureTabs[1].node[2].uuidNodo"
                  style="cursor: pointer"
                >
                  <b-form-select-option value="null"
                    >No especificado</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="data in selectPressureNodes"
                    v-bind:key="data"
                    v-bind:value="data"
                  >
                    {{ data }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label="Seleccione el nodo que mide las la presión en la cámara"
                label-for="largeChamber"
                style="max-width: 500px;"
              >
                <b-form-select
                  id="largeChamber"
                  name="largeChamber"
                  size="sm"
                  v-model="architectureTabs[1].node[0].uuidNodo"
                  style="cursor: pointer"
                >
                  <b-form-select-option value="null"
                    >No especificado</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="data in selectPressureNodes"
                    v-bind:key="data"
                    v-bind:value="data"
                  >
                    {{ data }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>

              <span class="small text-success mt-4">Pintura nueva</span><br>
              <b-form-group
                label-size="sm"
                label="Seleccione el nodo que mide la presión en la cámara en la etapa de EXTRACCIÓN"
                label-for="chamberNewPaintExtract"
                style="max-width: 500px;"
              >
                <b-form-select
                  id="chamberNewPaintExtract"
                  name="chamberNewPaintExtract"
                  size="sm"
                  v-model="architectureTabs[2].node[0].uuidNodo"
                  style="cursor: pointer"
                >
                  <b-form-select-option value="null"
                    >No especificado</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="data in selectPressureNodes"
                    v-bind:key="data"
                    v-bind:value="data"
                  >
                    {{ data }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label="Seleccione el nodo que mide la presión en la entrecámara de los filtros para etapa de EXTRACCIÓN"
                label-for="filterLRNewPaintExtract"
                style="max-width: 500px;"
              >
                <b-form-select
                  id="filterLRNewPaintExtract"
                  name="filterLRNewPaintExtract"
                  size="sm"
                  v-model="architectureTabs[2].node[1].uuidNodo"
                  style="cursor: pointer"
                >
                  <b-form-select-option value="null"
                    >No especificado</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="data in selectPressureNodes"
                    v-bind:key="data"
                    v-bind:value="data"
                  >
                    {{ data }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label="Seleccione el nodo que mide las presiones entre los filtros izquierdos y los motores para etapa de EXTRACCIÓN"
                label-for="filter2EngineNewPaintExtract"
                style="max-width: 500px;"
              >
                <b-form-select
                  id="filter2EngineNewPaintExtract"
                  name="filter2EngineNewPaintExtract"
                  size="sm"
                  v-model="architectureTabs[2].node[2].uuidNodo"
                  style="cursor: pointer"
                >
                  <b-form-select-option value="null"
                    >No especificado</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="data in selectPressureNodes"
                    v-bind:key="data"
                    v-bind:value="data"
                  >
                    {{ data }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label="Seleccione el nodo que mide la presión en la cámara en la etapa de IMPULSIÓN"
                label-for="chamberNewPaintImpulse"
                style="max-width: 500px;"
              >
                <b-form-select
                  id="chamberNewPaintImpulse"
                  name="chamberNewPaintImpulse"
                  size="sm"
                  v-model="architectureTabs[2].node[3].uuidNodo"
                  style="cursor: pointer"
                >
                  <b-form-select-option value="null"
                    >No especificado</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="data in selectPressureNodes"
                    v-bind:key="data"
                    v-bind:value="data"
                  >
                    {{ data }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label="Seleccione el nodo que mide las presiones en la entrecámara de los filtros para etapa de IMPULSIÓN"
                label-for="filterLRNewPaintImpulse"
                style="max-width: 500px;"
              >
                <b-form-select
                  id="filterLRNewPaintImpulse"
                  name="filterLRNewPaintImpulse"
                  size="sm"
                  v-model="architectureTabs[2].node[4].uuidNodo"
                  style="cursor: pointer"
                >
                  <b-form-select-option value="null"
                    >No especificado</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="data in selectPressureNodes"
                    v-bind:key="data"
                    v-bind:value="data"
                  >
                    {{ data }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label="Seleccione el nodo que mide las presiones entre los filtros izquierdos y los motores para etapa de IMPULSIÓN"
                label-for="filter2EngineNewPaintImpulse"
                style="max-width: 500px;"
              >
                <b-form-select
                  id="filter2EngineNewPaintImpulse"
                  name="filter2EngineNewPaintImpulse"
                  size="sm"
                  v-model="architectureTabs[2].node[5].uuidNodo"
                  style="cursor: pointer"
                >
                  <b-form-select-option value="null"
                    >No especificado</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="data in selectPressureNodes"
                    v-bind:key="data"
                    v-bind:value="data"
                  >
                    {{ data }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>

              <span class="small text-success mt-4">Pintura antigua</span><br>
              <b-form-group
                label-size="sm"
                label="Seleccione el nodo que mide la presión en la cámara en la etapa de EXTRACCIÓN"
                label-for="chamberOldPaintExtract"
                style="max-width: 500px;"
              >
                <b-form-select
                  id="chamberOldPaintExtract"
                  name="chamberOldPaintExtract"
                  size="sm"
                  v-model="architectureTabs[3].node[0].uuidNodo"
                  style="cursor: pointer"
                >
                  <b-form-select-option value="null"
                    >No especificado</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="data in selectPressureNodes"
                    v-bind:key="data"
                    v-bind:value="data"
                  >
                    {{ data }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label="Seleccione el nodo que mide la presión en la entrecámara de los filtros para etapa de EXTRACCIÓN"
                label-for="filterLROldPaintExtract"
                style="max-width: 500px;"
              >
                <b-form-select
                  id="filterLROldPaintExtract"
                  name="filterLROldPaintExtract"
                  size="sm"
                  v-model="architectureTabs[3].node[1].uuidNodo"
                  style="cursor: pointer"
                >
                  <b-form-select-option value="null"
                    >No especificado</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="data in selectPressureNodes"
                    v-bind:key="data"
                    v-bind:value="data"
                  >
                    {{ data }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label="Seleccione el nodo que mide las presiones entre los filtros izquierdos y los motores (1 a 4) para etapa de EXTRACCIÓN"
                label-for="filter2EngineOld14PaintExtract"
                style="max-width: 500px;"
              >
                <b-form-select
                  id="filter2EngineOld14PaintExtract"
                  name="filter2EngineOld14PaintExtract"
                  size="sm"
                  v-model="architectureTabs[3].node[2].uuidNodo"
                  style="cursor: pointer"
                >
                  <b-form-select-option value="null"
                    >No especificado</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="data in selectPressureNodes"
                    v-bind:key="data"
                    v-bind:value="data"
                  >
                    {{ data }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label="Seleccione el nodo que mide las presiones entre los filtros izquierdos y los motores (5 a 8) para etapa de EXTRACCIÓN"
                label-for="filter2EngineOld58PaintExtract"
                style="max-width: 500px;"
              >
                <b-form-select
                  id="filter2EngineOld58PaintExtract"
                  name="filter2EngineOld58PaintExtract"
                  size="sm"
                  v-model="architectureTabs[3].node[3].uuidNodo"
                  style="cursor: pointer"
                >
                  <b-form-select-option value="null"
                    >No especificado</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="data in selectPressureNodes"
                    v-bind:key="data"
                    v-bind:value="data"
                  >
                    {{ data }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label="Seleccione el nodo que mide la presión en la cámara en la etapa de IMPULSIÓN"
                label-for="chamberOldPaintImpulse"
                style="max-width: 500px;"
              >
                <b-form-select
                  id="chamberOldPaintImpulse"
                  name="chamberOldPaintImpulse"
                  size="sm"
                  v-model="architectureTabs[3].node[4].uuidNodo"
                  style="cursor: pointer"
                >
                  <b-form-select-option value="null"
                    >No especificado</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="data in selectPressureNodes"
                    v-bind:key="data"
                    v-bind:value="data"
                  >
                    {{ data }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label="Seleccione el nodo que mide las presiones en la entrecámara de los filtros para etapa de IMPULSIÓN"
                label-for="filterLROldPaintImpulse"
                style="max-width: 500px;"
              >
                <b-form-select
                  id="filterLROldPaintImpulse"
                  name="filterLROldPaintImpulse"
                  size="sm"
                  v-model="architectureTabs[3].node[5].uuidNodo"
                  style="cursor: pointer"
                >
                  <b-form-select-option value="null"
                    >No especificado</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="data in selectPressureNodes"
                    v-bind:key="data"
                    v-bind:value="data"
                  >
                    {{ data }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label="Seleccione el nodo que mide las presiones entre los filtros izquierdos y los motores para etapa de IMPULSIÓN"
                label-for="filter2EngineOldPaintImpulse"
                style="max-width: 500px;"
              >
                <b-form-select
                  id="filter2EngineOldPaintImpulse"
                  name="filter2EngineOldPaintImpulse"
                  size="sm"
                  v-model="architectureTabs[3].node[6].uuidNodo"
                  style="cursor: pointer"
                >
                  <b-form-select-option value="null"
                    >No especificado</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="data in selectPressureNodes"
                    v-bind:key="data"
                    v-bind:value="data"
                  >
                    {{ data }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
              <div class="mt-4">
                <button class="btn btn-success" type="submit">Guardar</button>
              </div>
            </b-form>
          </div>

        </b-tab>


        <!-- Render this if no tabs -->
        <template v-slot:empty>
          <div class="text-center text-muted">
            Todavía no hay información sobre el estado de los filtros.
          </div>
        </template>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>

import SVG_Filters from "@/components/filters/SVG_Filters";
import DataService from "@/services/DataService.js";
import DeviceService from "@/services/DeviceService.js";

export default {
    data () {
        return {
          tabIndex: 0,
          architectureTabs: [
            {
              name: 'Granalla Pequeña',
              type: 'smallGrit',
              node: [
                {uuidNodo: null, idSensor: null, index: 0}, 
                {uuidNodo: null, idSensor: null, index: 1}
              ]
            },
            {
              name: 'Granalla Grande',
              type: 'largeGrit',
              node: [
                {uuidNodo: null, idSensor: null, index: 0},
                {uuidNodo: null, idSensor: null, index: 1},
                {uuidNodo: null, idSensor: null, index: 2}
              ]
            },
            {
              name: 'Pintura Nueva',
              type: 'newPaint',
              node: [
                {uuidNodo: null, idSensor: null, index: 0},
                {uuidNodo: null, idSensor: null, index: 1},
                {uuidNodo: null, idSensor: null, index: 2},
                {uuidNodo: null, idSensor: null, index: 3},
                {uuidNodo: null, idSensor: null, index: 4},
                {uuidNodo: null, idSensor: null, index: 5}
              ]
            },
            {
              name: 'Pintura Antigua',
              type: 'oldPaint',
              node: [
                {uuidNodo: null, idSensor: null, index: 0},
                {uuidNodo: null, idSensor: null, index: 1},
                {uuidNodo: null, idSensor: null, index: 2},
                {uuidNodo: null, idSensor: null, index: 3},
                {uuidNodo: null, idSensor: null, index: 4},
                {uuidNodo: null, idSensor: null, index: 5},
                {uuidNodo: null, idSensor: null, index: 6}
              ]
            },
            {
              name: 'Configuración de filtros',
              type: 'config'
            },
          ],
          lastMeassurement: null,
          smallGritData : [],
          largeGritData: [],
          newPaintData: [],
          oldPaintData: [],
          thresholdUp: 5,
          tresholdDown: 2,
          isLoading: false,
          serverParams: {
            limit: 1,
            fullData: true
          },
          selectPressureNodes: []
        }
    },  
    components: {
      SVG_Filters
    },
    async mounted() {
      let response = await DeviceService.getDeviceFilterGroup();
      await this.parseResponse(response.data);
      this.retrieveData(this.architectureTabs[0].type, this.architectureTabs[0].node);
    },
    methods: {
      async retrieveData(type, nodes){
        this.isLoading = true;
        //console.log(type, nodes)
        if(type == 'smallGrit'){
          this.smallGritData = [];
        }
        if(type == 'largeGrit'){
          this.largeGritData = [];
        }
        if(nodes && nodes.length > 0){
          let date = null;
          let dateString = null;
          for await (let node of nodes){
            let response = null;
            if(node.idSensor){
              response = await DataService.getAllPressureVegabar29SensorData(node.idSensor, this.serverParams);
            }
            this.isLoading = false;
            //console.log(response.data != ''? "Este sensor tiene datos" : "Este sensor está vacío");
            if(response && response.data && response.data != ''){
              //console.log(response.data);
              let dataSchema = {}
              if((type == 'smallGrit' && node.index == 0) || (type == 'largeGrit' && node.index == 1)){
                dataSchema.filter2engine = response.data.data.presion_L1;
                dataSchema.filterRight =  response.data.data.presion_L2;
                dataSchema.filterLeft = response.data.data.presion_L3;
                dataSchema.statusRight = this.calculateStatus(response.data.data.presion_L1,response.data.data.presion_L2);
                dataSchema.statusLeft = this.calculateStatus(response.data.data.presion_L1,response.data.data.presion_L3);
              }
              if(
                  (type == 'smallGrit' && node.index == 1) || 
                  (type == 'largeGrit' && node.index == 0) || 
                  (type == 'newPaint' && node.index == 0) || 
                  (type == 'newPaint' && node.index == 3) || 
                  (type == 'oldPaint' && node.index == 0) || 
                  (type == 'oldPaint' && node.index == 4)
                ){
                dataSchema.chamberPressure = response.data.data.presion_L1;
              }
              if(type == 'largeGrit' && node.index == 2){
                dataSchema.filter2engineBis = response.data.data.presion_L1;
                dataSchema.filterRightBis =  response.data.data.presion_L2;
                dataSchema.filterLeftBis = response.data.data.presion_L3;
                dataSchema.statusRightBis = this.calculateStatus(response.data.data.presion_L1,response.data.data.presion_L2);
                dataSchema.statusLeftBis = this.calculateStatus(response.data.data.presion_L1,response.data.data.presion_L3);
              }

              if((type == 'newPaint' && node.index == 1) || (type == 'oldPaint' && node.index == 1)){
                dataSchema.filterLeftRight = response.data.data.presion_L1;
                if (type == 'newPaint'){
                  dataSchema.statusRight = this.calculateStatus(this.newPaintData[0].chamberPressure, response.data.data.presion_L1);
                }else{
                  dataSchema.statusRight = this.calculateStatus(this.oldPaintData[0].chamberPressure, response.data.data.presion_L1);
                }
              }

              if ((type == 'newPaint' && node.index == 2) || (type == 'oldPaint' && node.index == 2)){
                dataSchema.filter2engine_1 = response.data.data.presion_L1;
                dataSchema.filter2engine_2 = response.data.data.presion_L2;
                dataSchema.filter2engine_3 = response.data.data.presion_L3;
                dataSchema.filter2engine_4 = response.data.data.presion_L4;


                let filterLeftRight = null;
                if (type == 'newPaint'){
                  filterLeftRight = this.newPaintData[1].filterLeftRight;
                  dataSchema.filter2engine_5 = response.data.data.presion_L5;
                }else{
                  filterLeftRight = this.oldPaintData[1].filterLeftRight;
                }
                
                dataSchema.statusFilterEngine_1 = this.calculateStatus(filterLeftRight, response.data.data.presion_L1);
                dataSchema.statusFilterEngine_2 = this.calculateStatus(filterLeftRight, response.data.data.presion_L2);
                dataSchema.statusFilterEngine_3 = this.calculateStatus(filterLeftRight, response.data.data.presion_L3);
                dataSchema.statusFilterEngine_4 = this.calculateStatus(filterLeftRight, response.data.data.presion_L4);
                if (type == 'newPaint'){
                  dataSchema.statusFilterEngine_5 = this.calculateStatus(filterLeftRight, response.data.data.presion_L5);
                }
              }

              if (type == 'oldPaint' && node.index == 3){
                dataSchema.filter2engine_5 = response.data.data.presion_L1;
                dataSchema.filter2engine_6 = response.data.data.presion_L2;
                dataSchema.filter2engine_7 = response.data.data.presion_L3;
                dataSchema.filter2engine_8 = response.data.data.presion_L4;

                let filterLeftRight = this.oldPaintData[1].filterLeftRight;

                dataSchema.statusFilterEngine_5 = this.calculateStatus(filterLeftRight, response.data.data.presion_L1);
                dataSchema.statusFilterEngine_6 = this.calculateStatus(filterLeftRight, response.data.data.presion_L2);
                dataSchema.statusFilterEngine_7 = this.calculateStatus(filterLeftRight, response.data.data.presion_L3);
                dataSchema.statusFilterEngine_8 = this.calculateStatus(filterLeftRight, response.data.data.presion_L4);
              }

              if((type == 'newPaint' && node.index == 4) || (type == 'oldPaint' && node.index == 5)){
                dataSchema.filterLeftRight_1 = response.data.data.presion_L1;
                dataSchema.filterLeftRight_2 = response.data.data.presion_L2;
                dataSchema.filterLeftRight_3 = response.data.data.presion_L3;

                let chamberPressure = null;
                if (type == 'newPaint'){
                  chamberPressure = this.newPaintData[3].chamberPressure;
                }else{
                  chamberPressure = this.oldPaintData[4].chamberPressure;
                }

                dataSchema.statusRight_1 = this.calculateStatus(response.data.data.presion_L1, chamberPressure);
                dataSchema.statusRight_2 = this.calculateStatus(response.data.data.presion_L2, chamberPressure);
                dataSchema.statusRight_3 = this.calculateStatus(response.data.data.presion_L3, chamberPressure);
              }

              if((type == 'newPaint' && node.index == 5) || (type == 'oldPaint' && node.index == 6)){
                dataSchema.filter2engine_1 = response.data.data.presion_L1;
                dataSchema.filter2engine_2 = response.data.data.presion_L2;
                dataSchema.filter2engine_3 = response.data.data.presion_L3;

                let filterLeftRight_1 = null;
                let filterLeftRight_2 = null;
                let filterLeftRight_3 = null;

                if (type == 'newPaint'){
                  filterLeftRight_1 = this.newPaintData[4].filterLeftRight_1;
                  filterLeftRight_2 = this.newPaintData[4].filterLeftRight_2;
                  filterLeftRight_3 = this.newPaintData[4].filterLeftRight_3;
                }else{
                  filterLeftRight_1 = this.oldPaintData[5].filterLeftRight_1;
                  filterLeftRight_2 = this.oldPaintData[5].filterLeftRight_2;
                  filterLeftRight_3 = this.oldPaintData[5].filterLeftRight_3;
                }

                dataSchema.statusFilterEngine_1 = this.calculateStatus(response.data.data.presion_L1, filterLeftRight_1);
                dataSchema.statusFilterEngine_2 = this.calculateStatus(response.data.data.presion_L2, filterLeftRight_2);
                dataSchema.statusFilterEngine_3 = this.calculateStatus(response.data.data.presion_L3, filterLeftRight_3);
              }

              if(type == 'smallGrit'){
                this.smallGritData.push(dataSchema);
              }else if(type == 'largeGrit'){
                this.largeGritData.push(dataSchema);
              }else if(type == 'newPaint'){
                this.newPaintData.push(dataSchema);
              }else if(type == 'oldPaint'){
                this.oldPaintData.push(dataSchema);
              }

              if(!date){
                date = new Date(response.data.createdAt).getTime();
                dateString = response.data.createdAt;
              }else{
                if(date < new Date(response.data.createdAt).getTime()){
                  date = new Date(response.data.createdAt).getTime();
                  dateString = response.data.createdAt;
                }
              }
            }
          }
          if(dateString){
            this.lastMeassurement = this.$moment(dateString).local().format("DD-MM-YYYY HH:mm:ss");
          }else{
            this.lastMeassurement = '';
          }
        }else{
          let response = await DeviceService.getPressureDeviceData();
          let uuidNodes = [];
          response.data.data.forEach(node => {
            uuidNodes.push(node.uuidNodo);
          });
          this.selectPressureNodes = JSON.parse(JSON.stringify(uuidNodes));
        }
      },
      parseResponse(DeviceFilterData){
        return new Promise( resolve => {
          this.architectureTabs[0].node = DeviceFilterData.data.filters.smallGrit.length > 0? DeviceFilterData.data.filters.smallGrit : this.architectureTabs[0].node;
          this.architectureTabs[1].node = DeviceFilterData.data.filters.largeGrit.length > 0? DeviceFilterData.data.filters.largeGrit : this.architectureTabs[1].node;
          this.architectureTabs[2].node = DeviceFilterData.data.filters.newPaint.length > 0? DeviceFilterData.data.filters.newPaint : this.architectureTabs[2].node;
          this.architectureTabs[3].node = DeviceFilterData.data.filters.oldPaint.length > 0? DeviceFilterData.data.filters.oldPaint : this.architectureTabs[3].node;
          resolve();
        })
      },
      async saveData(e){
        e.preventDefault();
        let data = {
          filters: {
            "smallGrit": [
              {
                "uuidNodo": this.architectureTabs[0].node[0].uuidNodo,
                "idSensor": (await DeviceService.getPressureSensorFromUuid(this.architectureTabs[0].node[0].uuidNodo)).data.data,
                "index": 0
              },
              {
                "uuidNodo": this.architectureTabs[0].node[1].uuidNodo,
                "idSensor": (await DeviceService.getPressureSensorFromUuid(this.architectureTabs[0].node[1].uuidNodo)).data.data,
                "index": 1
              }
            ],
            "largeGrit": [
              {
                "uuidNodo": this.architectureTabs[1].node[1].uuidNodo,
                "idSensor": (await DeviceService.getPressureSensorFromUuid(this.architectureTabs[1].node[1].uuidNodo)).data.data,
                "index": 0
              },
              {
                "uuidNodo": this.architectureTabs[1].node[2].uuidNodo,
                "idSensor": (await DeviceService.getPressureSensorFromUuid(this.architectureTabs[1].node[2].uuidNodo)).data.data,
                "index": 1
              },
              {
                "uuidNodo": this.architectureTabs[1].node[0].uuidNodo,
                "idSensor": (await DeviceService.getPressureSensorFromUuid(this.architectureTabs[1].node[0].uuidNodo)).data.data,
                "index": 2
              }
            ],
            "newPaint": [
              {
                "uuidNodo": this.architectureTabs[2].node[0].uuidNodo,
                "idSensor": (await DeviceService.getPressureSensorFromUuid(this.architectureTabs[2].node[0].uuidNodo)).data.data,
                "index": 0
              },
              {
                "uuidNodo": this.architectureTabs[2].node[1].uuidNodo,
                "idSensor": (await DeviceService.getPressureSensorFromUuid(this.architectureTabs[2].node[1].uuidNodo)).data.data,
                "index": 1
              },
              {
                "uuidNodo": this.architectureTabs[2].node[2].uuidNodo,
                "idSensor": (await DeviceService.getPressureSensorFromUuid(this.architectureTabs[2].node[2].uuidNodo)).data.data,
                "index": 2
              },
              {
                "uuidNodo": this.architectureTabs[2].node[3].uuidNodo,
                "idSensor": (await DeviceService.getPressureSensorFromUuid(this.architectureTabs[2].node[3].uuidNodo)).data.data,
                "index": 3
              },
              {
                "uuidNodo": this.architectureTabs[2].node[4].uuidNodo,
                "idSensor": (await DeviceService.getPressureSensorFromUuid(this.architectureTabs[2].node[4].uuidNodo)).data.data,
                "index": 4
              },
              {
                "uuidNodo": this.architectureTabs[2].node[5].uuidNodo,
                "idSensor": (await DeviceService.getPressureSensorFromUuid(this.architectureTabs[2].node[5].uuidNodo)).data.data,
                "index": 5
              }
            ],
            "oldPaint": [
              {
                "uuidNodo": this.architectureTabs[3].node[0].uuidNodo,
                "idSensor": (await DeviceService.getPressureSensorFromUuid(this.architectureTabs[3].node[0].uuidNodo)).data.data,
                "index": 0
              },
              {
                "uuidNodo": this.architectureTabs[3].node[1].uuidNodo,
                "idSensor": (await DeviceService.getPressureSensorFromUuid(this.architectureTabs[3].node[1].uuidNodo)).data.data,
                "index": 1
              },
              {
                "uuidNodo": this.architectureTabs[3].node[2].uuidNodo,
                "idSensor": (await DeviceService.getPressureSensorFromUuid(this.architectureTabs[3].node[2].uuidNodo)).data.data,
                "index": 2
              },
              {
                "uuidNodo": this.architectureTabs[3].node[3].uuidNodo,
                "idSensor": (await DeviceService.getPressureSensorFromUuid(this.architectureTabs[3].node[3].uuidNodo)).data.data,
                "index": 3
              },
              {
                "uuidNodo": this.architectureTabs[3].node[4].uuidNodo,
                "idSensor": (await DeviceService.getPressureSensorFromUuid(this.architectureTabs[3].node[4].uuidNodo)).data.data,
                "index": 4
              },
              {
                "uuidNodo": this.architectureTabs[3].node[5].uuidNodo,
                "idSensor": (await DeviceService.getPressureSensorFromUuid(this.architectureTabs[3].node[5].uuidNodo)).data.data,
                "index": 5
              },
              {
                "uuidNodo": this.architectureTabs[3].node[6].uuidNodo,
                "idSensor": (await DeviceService.getPressureSensorFromUuid(this.architectureTabs[3].node[6].uuidNodo)).data.data,
                "index": 6
              }
            ]
          }
        }
        DeviceService.saveDeviceFilterGroup(JSON.stringify(data)).then( response => {
          this.$notify({
            group: "notificateDiv",
            type: "success",
            title: "Arquitectura de filtros",
            text: response.data.message,
            duration: 3000,
            speed: 1000,
          });
          DeviceService.getDeviceFilterGroup().then( updatedData => {
            this.parseResponse(updatedData.data);
          });
        }).catch( error => {
          this.$notify({
            group: "notificateDiv",
            type: "error",
            title: "Arquitectura de filtros",
            text: error.data.message,
            duration: 3000,
            speed: 1000,
          });
        });
      },
      calculateStatus(upperPressure, lowerPressure){
        let result = {
          class: "",
          message: "ERROR"
        }
        if (upperPressure && lowerPressure){
          let difference = parseFloat(upperPressure) - parseFloat(lowerPressure);
          if (difference < this.tresholdDown){
            result.class = 'text-success';
            result.message = 'Buen estado';
          }else if(difference >= this.thresholdUp){
            result.class = 'text-danger';
            result.message = 'Colmatado';
          }else{
            result.class = 'text-warning';
            result.message = 'Sucio';
          }
        }
        return result;
      }
    }
}
</script>
<style scoped>
  table {
    background-color: rgb(222, 255, 255);
    min-width: 800px;
  }
</style>
